"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesSoldByPropertyType$ = exports.PropertiesSoldByPropertyType$outboundSchema = exports.PropertiesSoldByPropertyType$inboundSchema = void 0;
exports.propertiesSoldByPropertyTypeToJSON = propertiesSoldByPropertyTypeToJSON;
exports.propertiesSoldByPropertyTypeFromJSON = propertiesSoldByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statspropertytype_js_1 = require("./statspropertytype.js");
/** @internal */
exports.PropertiesSoldByPropertyType$inboundSchema = z.object({
    property_type: statspropertytype_js_1.StatsPropertyType$inboundSchema,
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.PropertiesSoldByPropertyType$outboundSchema = z.object({
    propertyType: statspropertytype_js_1.StatsPropertyType$outboundSchema,
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesSoldByPropertyType$;
(function (PropertiesSoldByPropertyType$) {
    /** @deprecated use `PropertiesSoldByPropertyType$inboundSchema` instead. */
    PropertiesSoldByPropertyType$.inboundSchema = exports.PropertiesSoldByPropertyType$inboundSchema;
    /** @deprecated use `PropertiesSoldByPropertyType$outboundSchema` instead. */
    PropertiesSoldByPropertyType$.outboundSchema = exports.PropertiesSoldByPropertyType$outboundSchema;
})(PropertiesSoldByPropertyType$ || (exports.PropertiesSoldByPropertyType$ = PropertiesSoldByPropertyType$ = {}));
function propertiesSoldByPropertyTypeToJSON(propertiesSoldByPropertyType) {
    return JSON.stringify(exports.PropertiesSoldByPropertyType$outboundSchema.parse(propertiesSoldByPropertyType));
}
function propertiesSoldByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesSoldByPropertyType$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesSoldByPropertyType' from JSON`);
}
//# sourceMappingURL=propertiessoldbypropertytype.js.map